import styled from "styled-components"

export default styled.table`
width: 100%;
border-collapse: collapse;
margin-bottom: 1em;
`
